
import Vue from "vue";
import Modal from "@/components/Modal.vue";
import { error } from "@/services/LoggerService";
export default Vue.extend({
  name: "BarrelClearedModal",
  components: { Modal },
  props: {},
  data: () => ({
    loading: false,
    duty: 0,
  }),
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
    sendBarrelClearedUpdate() {
      try {
        this.$emit("customsDuty", this.duty);
      } catch (err) {
        error(err);
        this.$emit("customsDuty", false);
      }
    },
  },
});
